import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';
import { PushNotificationService } from './services/pushNotificationService';

// Service Worker Registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('Service Worker enregistré avec succès:', registration);
      })
      .catch(error => {
        console.error('Erreur lors de l\'enregistrement du Service Worker:', error);
      });
  });
}

// Fonction pour vérifier l'état de la connexion
const checkNetworkStatus = () => {
  if (!navigator.onLine) {
    // Si nous sommes hors ligne, vérifier si la page offline existe dans le cache
    if (caches) {
      caches.match('/offline.html').then(response => {
        if (response) {
          // Rediriger vers la page hors ligne
          window.location.href = '/offline.html';
        }
      });
    }
  }
};

// Vérifier l'état du réseau au chargement
window.addEventListener('load', checkNetworkStatus);

// Fonction pour demander la permission des notifications
async function requestNotificationPermission() {
  const hasPermission = await PushNotificationService.requestPermission();
  if (hasPermission) {
    await PushNotificationService.subscribeToPush();
  }
}

// Demander la permission après un certain délai pour ne pas perturber l'expérience utilisateur
setTimeout(() => {
  requestNotificationPermission();
}, 5000); // Attendre 5 secondes après le chargement

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);